import { withInstall } from '@fx-front-framework/utils/with-install'
import VProportionPieChart from './src/index.vue'

export const FxVProportionPieChart = withInstall(VProportionPieChart)
export default FxVProportionPieChart

export * from './src/types'
